import type { FeatureFlagConfig } from '@seek/candidate-feature-flag';

/**
 * All feature flags in this array will be fetched from launch darkly (via the candidate graph)
 * as chalice server-side renders
 */
export const featureFlagsToFetch: FeatureFlagConfig[] = [];
